import { FC } from 'react';

import { styled } from '@mui/material/styles';

const TERMS_HTML_URL =
  'https://storage.googleapis.com/expain_documents/Patient%20App%20Agreement.html';

const Terms: FC = () => {
  return <StyledIframe src={TERMS_HTML_URL} title="Patient App Agreement" />;
};

const StyledIframe = styled('iframe')`
  width: 100%;
  height: 100%;
  border: none;
`;
export default Terms;
